module.exports = __webpack_public_path__ + "img/kaspikz_horiz_new.4e92e52a.svg";